import React, { createContext, useState, useCallback, useEffect } from 'react';

const STORAGE_KEY = 'actingAsRespondent';

const ActingAsContext = createContext();

const readFromStorage = () => {
    try {
        const raw = sessionStorage.getItem(STORAGE_KEY);
        if (!raw) return null;
        const parsed = JSON.parse(raw);
        if (parsed && parsed.respondent_id) return parsed;
        return null;
    } catch (e) {
        return null;
    }
};

const ActingAsProvider = ({ children }) => {

    const [actingAs, setActingAsState] = useState(() => readFromStorage());

    const setActingAs = useCallback((payload) => {
        if (!payload || !payload.respondent_id) {
            sessionStorage.removeItem(STORAGE_KEY);
            setActingAsState(null);
            return;
        }
        const next = {
            respondent_id: String(payload.respondent_id),
            bin: payload.bin ?? null,
            ru_name: payload.ru_name ?? null,
            kk_name: payload.kk_name ?? null,
        };
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(next));
        setActingAsState(next);
    }, []);

    const clearActingAs = useCallback(() => {
        sessionStorage.removeItem(STORAGE_KEY);
        setActingAsState(null);
    }, []);

    // Sync across tabs / window events (sessionStorage is per-tab but just in case)

    useEffect(() => {
        const onStorage = (e) => {
            if (e.key === STORAGE_KEY) {
                setActingAsState(readFromStorage());
            }
        };
        window.addEventListener('storage', onStorage);
        return () => window.removeEventListener('storage', onStorage);
    }, []);

    return (
        <ActingAsContext.Provider value={{
            actingAs,
            setActingAs,
            clearActingAs
        }}>
            {children}
        </ActingAsContext.Provider>
    );

};

export { ActingAsProvider, ActingAsContext, STORAGE_KEY };
